import { useState, useEffect } from 'react';
import './css/youtube.css';

const Youtube = (props) => {
    const [videoUrl, setVideoUrl] = useState(null);

    useEffect(() => {
        if(props.random=== 'yes'){
        const fetchRandomVideo = async() => {
            const res = await fetch(
                 `https://www.googleapis.com/youtube/v3/search?key=${props.apiKey}&channelId=${props.channelId}&part=snippet&type=video&maxResults=50`
            )
            const data = await res.json();
            if (!data.items) {
                console.error('YouTube API error:', data.error?.message);
                return;
            }
            const videos = data.items;
            const random = videos[Math.floor(Math.random() * videos.length)];
            setVideoUrl(`https://www.youtube.com/embed/${random.id.videoId}`);
        };

        fetchRandomVideo();
    }else{
        setVideoUrl(`${props.video}`);
    }
}, [props.channelId, props.video, props.random]);

    if (!videoUrl) return null;
    

    return (
        <div className='youtube-container'>    
           <iframe className='youtube-frame'
            src={videoUrl} 
            title={props.title} 
            frameborder="0" 
            allow="accelerometer; 
            autoplay; 
            clipboard-write; 
            encrypted-media; 
            gyroscope; 
            picture-in-picture; 
            web-share"
            allowfullscreen></iframe>
        </div>
    );
}

export default Youtube;
